export const SIGNUP_URL = "https://business-app.theflip.app/public/signup/";
